/* eslint-disable no-unused-vars */
export enum InstrumentTypeCode {
  EXO = "EXO",
  FUT = "FUT",
  OPT = "OPT",
  FRA = "FRA",
  CDS = "CDS",
  IXB = "IXB",
  MM = "MM",
  FX = "FX",
  BND = "BND",
  FRN = "FRN",
  ABS = "ABS",
  REPO = "REPO",
  SWP = "SWP",
  COLL = "COLL",
}
